export const FILTER_FIELDS = [
  {
    type: 'text',
    name: 'name',
    label: 'Name',
    value: ''
  },
  {
    type: 'date',
    name: 'created_at',
    label: 'Created At',
    value: ''
  },
  {
    type: 'dropdown',
    name: 'directory_category_uuid',
    label: 'Category',
    value: '',
    apiUrl: 'directory-categories/list?fields=uuid,name',
    search_related: 'category'
  },
  {
    type: 'dropdown',
    name: 'published',
    label: 'Published',
    value: '',
    options: [
      {
        text: 'Yes',
        value: '1'
      },
      {
        text: 'No',
        value: '0'
      }
    ]
  },
];
